

import WarehouseIcon from '@mui/icons-material/Warehouse';

import { ReactComponent as Amazon } from '../../../../styles/svg/marketplace/amazon-app-icon.svg';
import AccessAlarmsIcon from '@mui/icons-material/AccessAlarms';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import BedtimeIcon from '@mui/icons-material/Bedtime';
import CancelIcon from '@mui/icons-material/Cancel';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import PrintOutlinedIcon from '@mui/icons-material/PrintOutlined';
import PauseCircleOutlineIcon from '@mui/icons-material/PauseCircleOutline';
import ScheduleSendIcon from '@mui/icons-material/ScheduleSend';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

// Dropdown sections for the views menu, in display order. `title` is an i18n key.
export const VIEW_GROUPS = [
    { key: 'processing', title: 'view_group_processing' },
    { key: 'actionRequired', title: 'view_group_action_required' },
    { key: 'externalReplenishments', title: 'view_group_external_replenishments' },
    { key: 'completed', title: 'view_group_completed' },
    { key: 'other', title: 'view_group_other' },
];

// showLabelPrintPending: the labels to print view, only when orders can be finalized without label
// hasAmazonManagePermission: the Amazon FBA view, only for users holding amazon_manage
export const warehouseOutboundOrdersConfig = (isFulfilment, orderTotals, showLabelPrintPending = false, hasAmazonManagePermission = false) => {
    return {
        orders:  {
            title: 'open_count',
            icon: <Inventory2OutlinedIcon/>,
            isSingleDataGrid: true,
            group: 'processing',
            ...(orderTotals && {count: orderTotals.open})
        },
        paused:  {
            title: 'warehouse_action_required',
            icon: <PauseCircleOutlineIcon/>,
            isSingleDataGrid: true,
            group: 'actionRequired',
            severity: 'attention',
            ...(orderTotals && {count: orderTotals.paused})
        },
        replenish:  {
            title: 'replenish',
            icon: <AutorenewIcon/>,
            isSingleDataGrid: true,
            group: 'processing',
            ...(orderTotals && {count: orderTotals.replenish})
        },
        postponed:  {
            title: 'postponed',
            icon: <AccessAlarmsIcon/>,
            isSingleDataGrid: true,
            group: 'processing',
            ...(orderTotals && {count: orderTotals.postponed})
        },
        shipped:  {
            title: 'shipped',
            icon: <LocalShippingIcon/>,
            isSingleDataGrid: true,
            group: 'completed',
        },
        snoozed:  {
            title: 'snoozed',
            icon: <BedtimeIcon/>,
            isSingleDataGrid: true,
            group: 'actionRequired',
            ...(orderTotals && {count: orderTotals.snoozed})
        },
        ...(showLabelPrintPending && {
            labelPrintPending:  {
                title: 'label_print_pending',
                icon: <PrintOutlinedIcon/>,
                isSingleDataGrid: true,
                group: 'actionRequired',
                ...(orderTotals && {count: orderTotals.labelPrintPending})
            }
        }),
        actionRequired:  {
            title: isFulfilment ? 'customer_action_required' : "office_action_required",
            icon: <WarningAmberIcon/>,
            isSingleDataGrid: true,
            group: 'actionRequired',
            severity: 'attention',
            ...(orderTotals && {count: orderTotals.action})
        },
        backorders:  {
            title: 'backordered',
            icon: <ScheduleSendIcon/>,
            isSingleDataGrid: true,
            group: 'processing',
            ...(orderTotals && {count: orderTotals.backorder})
        },
        cancelled:  {
            title: 'cancelled',
            icon: <CancelIcon/>,
            isSingleDataGrid: true,
            group: 'completed',
        },
        all:  {
            title: 'all_orders',
            icon: <FormatListBulletedIcon/>,
            isSingleDataGrid: true,
            group: 'completed',
        },
        bol:  {
            title: 'bol_lvb',
            icon: <WarehouseIcon/>,
            isSingleDataGrid: true,
            group: 'externalReplenishments',
            ...(orderTotals && {count: orderTotals.bolReplen})
        },
        // Gated behind amazon_manage: every FBA endpoint 403s without it, so an ungated tab would just render errors.
        ...(hasAmazonManagePermission && {
            amazonFba:  {
                title: 'amazon_fba',
                icon: <Amazon width={20} height={20} />,
                isSingleDataGrid: true,
                group: 'externalReplenishments',
            }
        }),
        // ...(isFulfilment && {
        //     customerOrders:  {
        //         title: 'customer_orders',
        //         icon: <PersonOutlineIcon/>,
        //         isSingleDataGrid: true,
        //     }
        // }),
        shipments:  {
            title: 'shipments',
            icon: <WarehouseIcon/>,
            isSingleDataGrid: true,
            group: 'completed',
        },
        ...(!isFulfilment && {
            importLogs:  {
                title: 'order_import_logs',
                icon: <WarehouseIcon/>,
                isSingleDataGrid: true,
                group: 'other',
                ...(orderTotals && {count: orderTotals.import})
            }
        }),
    };
};
